function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
import { Helmet } from "react-helmet";
import { helmetJsonLdProp } from "react-schemaorg";
import PropTypes from "prop-types";
import DefaultPropTypes from "../utils/prop-types";
var ListView = /*#__PURE__*/function (_React$Component) {
  function ListView(props) {
    var _this;
    _classCallCheck(this, ListView);
    _this = _callSuper(this, ListView, [props]);
    _this.state = {
      openContentTypes: {},
      showContentTypes: {}
    };
    _this.onContentTypeClick = _this.onContentTypeClick.bind(_this);
    return _this;
  }
  _inherits(ListView, _React$Component);
  return _createClass(ListView, [{
    key: "onContentTypeClick",
    value: function onContentTypeClick(contentType) {
      var openContentTypes = this.state.openContentTypes;
      if (openContentTypes[contentType.id]) {
        delete openContentTypes[contentType.id];
      } else {
        openContentTypes[contentType.id] = true;
      }
      this.setState({
        openContentTypes: openContentTypes
      });
    }
  }, {
    key: "onShowContentTypeClick",
    value: function onShowContentTypeClick(contentType) {
      var _this$state = this.state,
        showContentTypes = _this$state.showContentTypes,
        openContentTypes = _this$state.openContentTypes;
      if (showContentTypes[contentType.id]) {
        delete showContentTypes[contentType.id];
        if (openContentTypes[contentType.id]) {
          delete openContentTypes[contentType.id];
        }
      } else {
        showContentTypes[contentType.id] = true;
      }
      this.setState({
        showContentTypes: showContentTypes
      });
    }
  }, {
    key: "showItem",
    value: function showItem(index, contentType) {
      return index < this.props.settings.maxListCount || this.state.openContentTypes[contentType.id];
    }
  }, {
    key: "createSchemaData",
    value: function createSchemaData() {
      return this.props.allItems.map(function (item) {
        return {
          "@type": "Question",
          name: item.name,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.text
          }
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        ListItemViewClass = _this$props.ListItemViewClass,
        VideoGalleryItemViewClass = _this$props.VideoGalleryItemViewClass,
        onItemClick = _this$props.onItemClick,
        settings = _this$props.settings,
        contentTypes = _this$props.contentTypes,
        dictionary = _this$props.dictionary,
        isDesktop = _this$props.isDesktop,
        onClose = _this$props.onClose,
        selectedItem = _this$props.selectedItem,
        componentType = _this$props.componentType,
        filters = _this$props.filters;
      var selectedFilters = filters.map(function (filter) {
        return filter.elements.filter(function (element) {
          return element.selected;
        }).map(function (item) {
          return item.name;
        });
      });
      var isFAQ = componentType === "faq" || componentType === "search-and-faq";
      var _this$state2 = this.state,
        openContentTypes = _this$state2.openContentTypes,
        showContentTypes = _this$state2.showContentTypes;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isFAQ && /*#__PURE__*/React.createElement(Helmet, {
        script: [helmetJsonLdProp({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: this.createSchemaData()
        })]
      }), /*#__PURE__*/React.createElement("div", {
        className: "resources outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "desktop-section outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-type-container outer-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-container"
      }, contentTypes.map(function (contentType) {
        var isOpen = !!openContentTypes[contentType.id];
        var hasOverflow = settings.maxListCount < contentType.filteredItems.length;
        var isVideoGallery = componentType === "video-gallery";
        var isOpenOnMobile = !!showContentTypes[contentType.id] && !isDesktop;
        var linksLoaded = isDesktop || isOpenOnMobile || isFAQ || isVideoGallery;
        return /*#__PURE__*/React.createElement("div", {
          id: contentType.id,
          key: contentType.id,
          className: "content-type"
        }, /*#__PURE__*/React.createElement("div", {
          className: "content-type__header",
          onClick: function onClick() {
            _this2.onShowContentTypeClick(contentType);
          },
          onKeyPress: function onKeyPress(e) {
            return e.key === "Enter" && _this2.onShowContentTypeClick(contentType);
          },
          role: "button",
          tabIndex: linksLoaded ? "-1" : "0"
        }, /*#__PURE__*/React.createElement("h2", null, contentType.name, /*#__PURE__*/React.createElement("span", {
          className: "content-type-count"
        }, contentType.filteredItems.length))), linksLoaded && /*#__PURE__*/React.createElement("div", {
          className: "content-type-content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "content-type-files"
        }, contentType.filteredItems.map(function (item, index) {
          return _this2.showItem(index, contentType) ? /*#__PURE__*/React.createElement(React.Fragment, {
            key: item.id
          }, !isVideoGallery && /*#__PURE__*/React.createElement(ListItemViewClass, {
            key: item.id,
            dictionary: dictionary,
            item: item,
            isFAQ: isFAQ,
            isSearchAndFAQ: componentType === "search-and-faq",
            onClose: onClose,
            onItemClick: onItemClick,
            selectedItem: selectedItem,
            selectedFilters: selectedFilters
          }), isVideoGallery && /*#__PURE__*/React.createElement(VideoGalleryItemViewClass, {
            item: item,
            onItemClick: onItemClick,
            onClose: onClose,
            index: index,
            settings: settings,
            dictionary: dictionary,
            isDesktop: isDesktop,
            selectedItem: selectedItem
          })) : null;
        })), hasOverflow && /*#__PURE__*/React.createElement("button", {
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.onContentTypeClick(contentType);
          },
          className: "expand-button",
          "aria-expanded": isOpen,
          "aria-controls": contentType.id
        }, isOpen ? dictionary.back : dictionary.viewallitems.format(contentType.filteredItems.length))));
      }))))))));
    }
  }]);
}(React.Component);
ListView.propTypes = {
  settings: DefaultPropTypes.settings.isRequired,
  dictionary: DefaultPropTypes.dictionary.isRequired,
  ListItemViewClass: PropTypes.func.isRequired,
  contentTypes: DefaultPropTypes.contentTypes.isRequired,
  onItemClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool,
  selectedItem: DefaultPropTypes.item,
  componentType: PropTypes.string
};
ListView.defaultProps = {
  isDesktop: false,
  selectedItem: null,
  componentType: ""
};
export default ListView;